module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.b907762.eot";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fonts/Roboto-Regular/Roboto-Regular.eot
// module id = pf7v
// module chunks = 17